export default __webpack_public_path__ + "static/media/burger-icon.3ef48928.svg";